<template>
  <div>
    <div class="errPage-container">
      <el-row>
        <el-col :span="12">
          <p style="margin-left: 9px" class="text-jumbo">
            Oops! aucun resultat ...
          </p>

          <router-link
            :to="{
              name: '/',
            }"
          >
            <CButton
              style="
                margin-bottom: 7px;
                border-radius: 15px 18px;
                margin-top: 1px;
                margin-left: 4px;
                padding: 10px;
              "
              color="info"
              class="mr-1 cl"
            >
              Accueil
            </CButton>
          </router-link>
        </el-col>
        <el-col style="margin-top: -8px; margin-left: 2px">
          <img
            src="../assets/401_images/401.gif"
            width="355"
            height="547"
            alt="Girl has dropped her ice cream."
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { apiDomain } from "./../config.js";
export default {
  name: "Presentation",
  components: {},
  data() {
    return {
      c1: "",
      c2: "",
      search: "",
      error: "",
      /* *********** */
    };
  },
  methods: {
    addContact() {
      this.axios
        .post(`${apiDomain}/api/submit`, this.contact)
        .then((response) => {
          this.mailPro = "mailto:" + this.emailPanne;
          this.$router.push({ name: "Accueil" });
          this.$noty.success(
            "Votre message a été bien enregistré,nous vous repandrons dés que possible"
          );
        })
        .catch((error) => {
          console.log(error.response.data);
          if (error.response.status == 422) {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
  computed: {
    res_search() {
      return (this.search = this.c1 + " " + "TN" + " " + this.c2);
    },
  },
};
</script>

<style>
@media screen and (max-width: 700px) {
  .carbrands-mobile {
    margin-top: 0px !important;
  }
}

div.sp-manu-slider .item {
  padding: 20px 0;
  text-align: center;
  border-right: 0px;
}

div.sp-manu-slider {
  direction: ltr;
  position: relative;
  border: 0px;
}
</style>

<style>
div.spas-btn .btn.btn-search:before {
  display: none !important;
}

.fa-spin-auto {
  margin-left: -12px;
  margin-right: 8px;
}

.fa-search-auto {
  margin-left: -12px;
  margin-right: 8px;
}

.dropdown-style {
  background-color: #3c363699 !important;
  color: white !important;
  font-weight: bold !important;
  font-size: 16px !important;
}
</style>
                <style>
.grecaptcha-badge {
  display: none !important;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-link.active:focus,
.nav-tabs .nav-link.active:hover,
.nav-tabs .nav-item.open .nav-link,
.nav-tabs .nav-item.open .nav-link:focus,
.nav-tabs .nav-item.open .nav-link:hover {
  background-color: #211a18a6;
  border-color: #f8c635 #f8c635 transparent;
}

.nav-tabs {
  border-bottom: 1px solid #f8c635;
}

.spas-form-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.carmodel-style {
  width: 70% !important;
  padding-bottom: 4px !important;
  color: black;
}

@media screen and (max-width: 700px) {
  .searchbackground-mobile {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 18%,
      rgba(248, 198, 52, 1) 50%,
      rgba(255, 255, 255, 1) 83%
    ) !important;
    background-image: none;
  }
}

.searchbackground {
  background-image: url("/themes/sp_autostore/modules/spattributessearch/views/img/backgroundsearch.png");
}

@media screen and (max-width: 700px) {
  .header-mobile {
    text-shadow: 2px 2px #131315 !important;
    color: #f8c634 !important;

    margin: 1px;
  }
}
</style>

                      <style>
.as_cat_box {
  box-shadow: #505247 6px 6px 10px 1px;
  border-radius: 15px !important;
}

div.hot-categories .title-html h3.block-title:before,
div.hot-categories .title-html h3.block-title:after {
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: black;
  top: auto;
  bottom: 15px;
}

div.hot-categories .cat .img {
  width: 40%;
  padding-right: 10px;
  padding-left: 5px;
  text-align: center;
}

div.hot-categories .cat .img,
div.hot-categories .cat .info {
  display: inline-block;
  font-size: 14px;
  padding: 20px 5px 5px;
  vertical-align: middle;
}
</style>